<template>
  <div id="receive">
    <br>
    <h5 class="left bold">
      รายการผลการทดสอบ
    </h5>
    <br>
    <br>
    <report-table />
  </div>
</template>

<script>
    import ReportTable from "../../components/Report/ReportTable"
    import { mapActions } from 'vuex'
    import printJS from 'print-js'

  export default {
    name: "Report",
      components: { ReportTable },
  }
</script>

<style scoped>
    #receive {
        width: 95vw;
        margin: 0 auto;
    }
    .left {
        text-align: left;
    }
    .right {
        text-align: right;
    }
    .bold {
        font-weight: bold;
    }
</style>
